module.exports = __webpack_public_path__ + "static/media/play.f41b25b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.svg
// module id = 44
// module chunks = 0